var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstantBankAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5440_26304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.34985 11.0186H22.8322V25.443H5.34985V11.0186Z",
    fill: "#475F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.69556 10.4512H26.3141V11.5852H1.69556V10.4512Z",
    fill: "#DBD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.17163 24.4766H25.8384V26.41H2.17163V24.4766Z",
    fill: "#DBD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.06152 26.0234H26.9479V28.0006H1.06152V26.0234Z",
    fill: "#EEEFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0049 0L0.0366211 10.4518H27.9732L14.0049 0Z",
    fill: "#EEEFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2478 9.29796L14.0046 1.20605L24.761 9.29796H3.2478Z",
    fill: "#DBD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.67896 12.791H7.0206V23.3145H3.67896V12.791Z",
    fill: "#DBD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09619 11.585H7.60362V12.5807C7.60362 12.8183 7.411 13.011 7.17336 13.011H3.52645C3.28882 13.011 3.09619 12.8183 3.09619 12.5807V11.585Z",
    fill: "#EEEFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52675 23.0938H7.17262C7.41026 23.0938 7.60288 23.2864 7.60288 23.524V24.4771H3.09546V23.5244C3.09528 23.2867 3.28772 23.0939 3.52535 23.0938H3.52675Z",
    fill: "#E4E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3342 12.791H15.6759V23.3145H12.3342V12.791Z",
    fill: "#DBD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.751 11.585H16.2584V12.5807C16.2584 12.8183 16.0658 13.011 15.8282 13.011H12.1815C11.9439 13.011 11.7513 12.8183 11.7513 12.5807V11.585H11.751Z",
    fill: "#EEEFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1816 23.0938H15.8279C16.0655 23.0938 16.2581 23.2864 16.2581 23.524V24.4771H11.751V23.5244C11.7508 23.2867 11.9432 23.094 12.1809 23.0938H12.1816Z",
    fill: "#E4E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9888 12.791H24.3304V23.3145H20.9888V12.791Z",
    fill: "#DBD8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4065 11.585H24.9139V12.5807C24.9139 12.8183 24.7213 13.011 24.4837 13.011H20.8368C20.5991 13.011 20.4065 12.8183 20.4065 12.5807V11.585Z",
    fill: "#EEEFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8364 23.0938H24.4827C24.7203 23.0938 24.9129 23.2864 24.9129 23.524V24.4771H20.4055V23.5244C20.4053 23.2867 20.5978 23.0939 20.8354 23.0938H20.8364Z",
    fill: "#E4E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4174 4.6151C15.4176 5.39341 14.7868 6.02452 14.0085 6.0247C14.0074 6.0247 14.0062 6.0247 14.0051 6.0247C13.2277 6.0221 12.5981 5.3925 12.5955 4.6151C12.5959 3.83644 13.2276 3.20557 14.0063 3.20605C14.7675 3.20654 15.3909 3.81121 15.4147 4.57209C15.4176 4.58625 15.4185 4.60071 15.4174 4.6151Z",
    fill: "#475F84"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 7,
    fill: "#4B93FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5440_26304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8699 19.6387L29.3463 20.3945C29.4969 20.4404 29.5506 20.6259 29.4479 20.7452L26.8988 23.7065C26.7961 23.8258 26.8499 24.0113 27.0004 24.0572L28.1064 24.3948C28.2613 24.4421 28.3124 24.6357 28.2011 24.7533L25.6477 27.4476C25.5363 27.5651 25.5874 27.7588 25.7423 27.8061L26.1829 27.9405C26.3741 27.9989 26.4125 28.2528 26.2471 28.3652L22.647 30.8094C22.4352 30.9531 22.1918 30.6774 22.3607 30.4851L23.969 28.6543C24.0703 28.539 24.0239 28.3579 23.8797 28.3055L22.9997 27.9855C22.8508 27.9313 22.8076 27.7414 22.9184 27.6281L25.1088 25.3891C25.2231 25.2722 25.1729 25.0758 25.0166 25.0281L23.4737 24.5572C23.3378 24.5157 23.2773 24.3574 23.3508 24.2359L26.6197 19.7344C26.6714 19.649 26.7745 19.6095 26.8699 19.6387V19.6387Z",
    fill: "#FFEBA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1066 24.3949L27.0006 24.0573C26.85 24.0113 26.7963 23.8259 26.899 23.7065L29.4481 20.7453C29.5508 20.626 29.497 20.4405 29.3465 20.3946L26.8701 19.6387C26.7746 19.6096 26.6715 19.649 26.6199 19.7345L26.4816 19.9249L28.3616 20.4987C28.5121 20.5446 28.5659 20.7301 28.4632 20.8494L25.9141 23.8107C25.8114 23.93 25.8651 24.1155 26.0157 24.1614L27.1217 24.499C27.2766 24.5462 27.3277 24.7399 27.2163 24.8575L24.6629 27.5518C24.5515 27.6693 24.6026 27.863 24.7576 27.9103L25.1981 28.0447C25.3894 28.1031 25.4278 28.357 25.2624 28.4693L22.461 30.3713L22.3609 30.4852C22.192 30.6775 22.4354 30.9532 22.6472 30.8095L26.2472 28.3652C26.4127 28.2529 26.3743 27.999 26.183 27.9406L25.7425 27.8061C25.5876 27.7589 25.5365 27.5652 25.6478 27.4476L28.2012 24.7533C28.3126 24.6358 28.2615 24.4421 28.1066 24.3949Z",
    fill: "#FDDF7C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5440_26304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5440_26304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(21.5029 18) rotate(16.9726)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantBankAccount);
export default __webpack_public_path__ + "static/media/instant-bank-account.9000a767cc1c0665c69967184ded728d.svg";
export { ForwardRef as ReactComponent };